<template>
    <action v-show="group.allocation_mode === 'group_fcfs' || group.self_reservations">
        <template slot="header">Buchungszeiten</template>

        <div class="mb-6">
            <select-menu v-model="settings.periodicity"
                         :values="['d', 'w']"
                         :text="['tagesbasis', 'wochenbasis']">
                Vorabreservierungen auf
            </select-menu>
        </div>

        <div class="mb-2">
            <toggle-group v-model="priority_1">

                Sonderregeln für Priorität 1 aktivieren

                <template slot="helper">
                    Nutzer mit dieser Priorität können freie Schreibtische erst ab einem festgelegten Zeitpunkt buchen.
                </template>

                <template slot="body">
                    <input-text v-show="priority_1" v-model="settings.opening_time_1" type="number">
                        Wieviele Stunden dürfen Nutzer im voraus buchen:
                        <template slot="helper">
                            Nutzer können Schreibtische auf Tages- oder Wochenbasis erst X-Stunden im voraus buchen. Beispiel: 5 Stunden + tagesbasis bedeutet, der Schreibtisch für den nächsten Tag ist ab 19Uhr am Vortag buchbar. Arbeitsfreie Tage werden ignoriert.
                        </template>
                    </input-text>
                </template>

            </toggle-group>
        </div>

        <div class="mb-2">
            <toggle-group v-model="priority_2">

                Sonderregeln für Priorität 2 aktivieren

                <template slot="helper">
                    Nutzer mit dieser Priorität können freie Schreibtische erst ab einem festgelegten Zeitpunkt buchen.
                </template>

                <template slot="body">
                    <input-text v-show="priority_2" v-model="settings.opening_time_2" type="number">
                        Wieviele Stunden dürfen Nutzer im voraus buchen:
                        <template slot="helper">
                            Nutzer können Schreibtische auf Tages- oder Wochenbasis erst X-Stunden im voraus buchen. Beispiel: 5 Stunden + tagesbasis bedeutet, der Schreibtisch für den nächsten Tag ist ab 19Uhr am Vortag buchbar. Arbeitsfreie Tage werden ignoriert.
                        </template>
                    </input-text>
                </template>

            </toggle-group>
        </div>

        <div class="mb-2">
            <toggle-group v-model="priority_3">

                Sonderregeln für Priorität 3 aktivieren

                <template slot="helper">
                    Nutzer mit dieser Priorität können freie Schreibtische erst ab einem festgelegten Zeitpunkt buchen.
                </template>

                <template slot="body">
                    <input-text v-show="priority_3" v-model="settings.opening_time_3" type="number">
                        Wieviele Stunden dürfen Nutzer im voraus buchen:
                        <template slot="helper">
                            Nutzer können Schreibtische auf Tages- oder Wochenbasis erst X-Stunden im voraus buchen. Beispiel: 5 Stunden + tagesbasis bedeutet, der Schreibtisch für den nächsten Tag ist ab 19Uhr am Vortag buchbar. Arbeitsfreie Tage werden ignoriert.
                        </template>
                    </input-text>
                </template>

            </toggle-group>
        </div>

        <div class="mb-2">
            <toggle-group v-model="priority_4">

                Sonderregeln für Priorität 4 aktivieren

                <template slot="helper">
                    Nutzer mit dieser Priorität können freie Schreibtische erst ab einem festgelegten Zeitpunkt buchen.
                </template>

                <template slot="body">
                    <input-text v-show="priority_4" v-model="settings.opening_time_4" type="number">
                        Wieviele Stunden dürfen Nutzer im voraus buchen:
                        <template slot="helper">
                            Nutzer können Schreibtische auf Tages- oder Wochenbasis erst X-Stunden im voraus buchen. Beispiel: 5 Stunden + tagesbasis bedeutet, der Schreibtisch für den nächsten Tag ist ab 19Uhr am Vortag buchbar. Arbeitsfreie Tage werden ignoriert.
                        </template>
                    </input-text>
                </template>

            </toggle-group>
        </div>

        <div class="mb-2">
            <toggle-group v-model="priority_5">

                Sonderregeln für Priorität 5 aktivieren

                <template slot="helper">
                    Nutzer mit dieser Priorität können freie Schreibtische erst ab einem festgelegten Zeitpunkt buchen.
                </template>

                <template slot="body">
                    <input-text v-show="priority_5" v-model="settings.opening_time_5" type="number">
                        Wieviele Stunden dürfen Nutzer im voraus buchen:
                        <template slot="helper">
                            Nutzer können Schreibtische auf Tages- oder Wochenbasis erst X-Stunden im voraus buchen. Beispiel: 5 Stunden + tagesbasis bedeutet, der Schreibtisch für den nächsten Tag ist ab 19Uhr am Vortag buchbar. Arbeitsfreie Tage werden ignoriert.
                        </template>
                    </input-text>
                </template>

            </toggle-group>
        </div>

        <template slot="action">
            <button-primary @click="submit">
                <i class="fa fa-save"></i> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import Action from "../UI/Action";
import ButtonPrimary from "../UI/ButtonPrimary";
import InputText from "../UI/InputText";
import SelectMenu from "../UI/SelectMenu";
import ToggleGroup from "../UI/ToggleGroup";

export default {
    name: "StoreOpen",
    components: {ToggleGroup, SelectMenu, InputText, ButtonPrimary, Action},
    inject: ['group'],

    data: (vm) => ({
        settings: vm.group.store_settings,
    }),

    computed: {
        priority_1: {
            get() {
                return this.settings.opening_time_1 !== null;
            },
            set(val) {
                this.settings.opening_time_1 = val ? 0 : null;
            }
        },
        priority_2: {
            get() {
                return this.settings.opening_time_2 !== null;
            },
            set(val) {
                this.settings.opening_time_2 = val ? 0 : null;
            }
        },
        priority_3: {
            get() {
                return this.settings.opening_time_3 !== null;
            },
            set(val) {
                this.settings.opening_time_3 = val ? 0 : null;
            }
        },
        priority_4: {
            get() {
                return this.settings.opening_time_4 !== null;
            },
            set(val) {
                this.settings.opening_time_4 = val ? 0 : null;
            }
        },
        priority_5: {
            get() {
                return this.settings.opening_time_5 !== null;
            },
            set(val) {
                this.settings.opening_time_5 = val ? 0 : null;
            }
        },
    },

    methods: {
        submit() {
            window.axios.post(`/admin/group`, {
                store: {
                    'opening_time_1': this.settings.opening_time_1,
                    'opening_time_2': this.settings.opening_time_2,
                    'opening_time_3': this.settings.opening_time_3,
                    'opening_time_4': this.settings.opening_time_4,
                    'opening_time_5': this.settings.opening_time_5,
                    'periodicity': this.settings.periodicity,
                },
            })
                .then((response) => {
                    location.reload();
                })
                .catch((error) => {
                    location.reload();
                });
        }
    }
}
</script>

<style scoped>

</style>
